import store from '@/store'

export const optionButtonDesfazer = [
  {
    button: true,
    text: 'Desfazer',
    funcaoButton: 'desfazerVagas',
    icon: 'recycle',
    variant: 'primary',
    tooltip: 'Desfazer',
    objpermCodigo: store.state.permissaoMenu.editar
  }
]
export const fieldsDesfazer = [
  {
    key: 'ordem',
    label: 'Ordem',
    sortable: true,
    tdClass: 'tdCadastro',
    tipo: 'number'
  },
  { key: 'idcampo', label: 'ID_Campo', sortable: true, tdClass: 'tdCadastro' },
  { key: 'valor', label: 'Valor', sortable: true, tdClass: 'tdCadastro' },
  {
    key: 'descricao',
    label: 'Descrição',
    sortable: true
  },
  { key: 'actions', label: '' }
]
